import Home from './Home.vue';
import intro from './intro.vue';
import statements from './statements.vue';
import entryAdded from './entryAdded.vue';
import myWellbeingDiary from './myWellbeingDiary.vue';
import statementDetails from './statementDetails.vue';
import share from './share.vue';
import noEntriesAdded from './noEntriesAdded.vue';
import helpAndSupport from './helpAndSupport.vue';

export default {
    Home,
    intro,
    statements,
    entryAdded,
    myWellbeingDiary,
    statementDetails,
    share,
    noEntriesAdded,
    helpAndSupport
}
